import React from "react";

export const Testimonials = (props) => {
  const testimonialTextStyle = {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>What our students say</h2>
        </div>
        <div className="testimonial-wrapper">
          <div className="testimonial-scroll">
            {props.data
              ? [...props.data, ...props.data].map((d, i) => (
                  <div key={`${d.name}-${i}`} className="testimonial-item-container">
                    <div className="testimonial">
                      <div className="testimonial-image">
                        {" "}
                        <img src={d.img} alt="" />{" "}
                      </div>
                      <div className="testimonial-content">
                        <p style={testimonialTextStyle}>"{d.text}"</p>
                        <div className="testimonial-meta"> - {d.name} </div>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    </div>
  );
};
